import { ERequestCallbackActionTypes } from '../../actions/requestCallback';
import { TReduxActions } from '../../types/redux';
import { IRequestCallbackState } from '../../types/requestCallback';

const initialState: IRequestCallbackState = {
  isPopupOpen: false,
  opener: null,
};

export function requestCallbackReducer(
  state: IRequestCallbackState = initialState,
  action: TReduxActions,
): IRequestCallbackState {
  switch (action.type) {
    case ERequestCallbackActionTypes.OpenPopup:
      return {
        ...state,
        isPopupOpen: true,
        opener: action.payload,
      };

    case ERequestCallbackActionTypes.ClosePopup:
      return {
        ...state,
        isPopupOpen: false,
        opener: null,
      };

    default:
      return state;
  }
}
